import { cloneDeep, omit } from 'lodash';

// TODO: As part of BB-6611 the signature should be chagned so that the returned type matches the
// returned value. Also remove the cast on the return value.
// export const removeFields = <T, K extends keyof T>(obj: T, fieldsToRemove: K[]): Omit<T, K> => {
export const removeFields = <T extends object>(obj: T, fieldsToRemove: (keyof T)[]): T => {
  const copy = cloneDeep(obj);
  // forcing the type back to T for
  return omit(copy, fieldsToRemove) as T;
};
